export const thumbAnimationt1 = {
	hidden: {
		x: -200,
		opacity: 0,
	},
	visible: {
		x: 0,
		opacity: 1,
		delay: 0.5,
		// amount: 0.2
	},
};
export const thumbAnimationt2 = {
	hidden: {
		y: 200,
		opacity: 0,
	},
	visible: {
		y: 0,
		opacity: 1,
		delay: 0.5,
		// amount: 0.2
	},
};
export const thumbAnimationt3 = {
	hidden: {
		x: 200,
		opacity: 0,
	},
	visible: {
		x: 0,
		opacity: 1,
		delay: 0.5,
		// amount: 0.2
	},
};
